// ABOUTME: Tooltip component for displaying integration features
// ABOUTME: Shows integration name with icon and list of capabilities

import { memo, type ReactNode } from "react"
import { TooltipHeader } from "./TooltipHeader"
import { TooltipCheckList } from "./TooltipList"

interface IntegrationTooltipProps {
  name: string
  icon?: ReactNode
  iconBgColor?: string
  features: string[]
  note?: string
  className?: string
}

export const IntegrationTooltip = memo(
  ({ name, icon, iconBgColor, features, note, className = "" }: IntegrationTooltipProps) => {
    return (
      <div className={`max-w-[260px] min-w-[200px] ${className}`}>
        <TooltipHeader
          title={name}
          icon={icon}
          iconBgColor={iconBgColor}
        />

        <TooltipCheckList items={features} />

        {note && <p className="mt-2 text-[11px] text-gray-400 leading-tight">{note}</p>}
      </div>
    )
  },
)

IntegrationTooltip.displayName = "IntegrationTooltip"
